import Api from '@/services/Api';

//User api cals
export default {
  getAllUserTargets(params) {
    return Api().get('/api/user-targets', { params });
  },
};
